export const DESCRIPTION_OF_CHANGE_MAX_LENGTH = 400;
export const PROJECT_DESCRIPTION_MAX_LENGTH = 400;
export const STATUS_CHANGE_REASON_MAX_LENGTH = 255;
export const HA_FLAGS_MAX_LENGTH = 3;
export const PROJECT_ALIAS_MAX_LENGTH = 100;

export enum ProjectStatus {
  Planned = "PLANNED",
  InProgress = "IN_PROGRESS",
  Completed = "COMPLETED",
  Cancelled = "CANCELLED",
}

export enum ProjectType {
  Reliance = "RELIANCE",
  RegulatoryReview = "REGULATORY_REVIEW",
  SharedWorkspace = "SHARED_WORKSPACE",
  RelianceDeprecated = "RELIANCE_DEPRECATED",
  RegulatoryReviewDeprecated = "REGULATORY_REVIEW_DEPRECATED",
}

export enum CreateProjectStep {
  ProjectType,
  ProjectInfo,
}

export enum ProcessingStatus {
  Pending = "PENDING",
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Accepted = "ACCEPTED",
}

type TProjectStatusTabs = {
  ALL: string;
  [ProjectStatus.Planned]: string;
  [ProjectStatus.InProgress]: string;
  [ProjectStatus.Completed]: string;
  [ProjectStatus.Cancelled]: string;
};

export const PROJECT_STATUS_TABS: TProjectStatusTabs = {
  ALL: "utilsProjectConstants.projectStatus.all",
  [ProjectStatus.Planned]: "utilsProjectConstants.projectStatus.planned",
  [ProjectStatus.InProgress]: "utilsProjectConstants.projectStatus.inProgress",
  [ProjectStatus.Completed]: "utilsProjectConstants.projectStatus.completed",
  [ProjectStatus.Cancelled]: "utilsProjectConstants.projectStatus.cancelled",
};

export const NUMBER_OF_VISIBLE_RECENT_PROJECTS = 3;

export enum EventType {
  CMC = "CMC",
  OriginalApplication = "ORIGINAL_APPLICATION",
  Efficacy = "EFFICACY",
  Labeling = "LABELING",
  Safety = "SAFETY",
  Other = "OTHER",
}

export enum EventSubtype {
  DrugSubstance = "DRUG_SUBSTANCE",
  DrugProduct = "DRUG_PRODUCT",
  NotApplicable = "N/A",
  RawMaterials = "RAW_MATERIALS",
  Facilities = "FACILITIES",
  Placebo = "PLACEBO",
  Other = "OTHER",
  Biopharmaceutics = "BIOPHARMACEUTICS",
  Pharmacokinetics = "PHARMACOKINETICS",
  Pharmacodynamics = "PHARMACODYNAMICS",
  EfficacyAndSafety = "EFFICACY_AND_SAFETY",
  PostMarketing = "POST_MARKETING",
  NewIndication = "NEW_INDICATION",
  CMCChange = "CMC_CHANGE",
  SafetyUpdates = "SAFETY_UPDATES",
  Administrative = "ADMINISTRATIVE",
  Pharmacovigilance = "PHARMACOVIGILANCE",
  Pharmacology = "PHARMACOLOGY",
  Toxicology = "TOXICOLOGY",
}

export enum RegulatoryEvent {
  InitialApplication = "INITIAL_APPLICATION",
  PostApprovalChange = "POST_APPROVAL_CHANGE",
  ScientificAdvice = "SCIENTIFIC_ADVICE",
  NonApplicationSpecific = "NON_APPLICATION_SPECIFIC",
  Investigational = "INVESTIGATIONAL",
  RegulatoryMeetings = "REGULATORY_MEETINGS",
}

export const EventTypes = {
  [EventType.OriginalApplication]: [],
  [EventType.CMC]: [
    EventSubtype.DrugSubstance,
    EventSubtype.DrugProduct,
    EventSubtype.RawMaterials,
    EventSubtype.Facilities,
    EventSubtype.Placebo,
    EventSubtype.Other,
  ],
  [EventType.Efficacy]: [
    EventSubtype.Biopharmaceutics,
    EventSubtype.Pharmacokinetics,
    EventSubtype.Pharmacodynamics,
    EventSubtype.EfficacyAndSafety,
    EventSubtype.PostMarketing,
    EventSubtype.Other,
  ],
  [EventType.Labeling]: [
    EventSubtype.NewIndication,
    EventSubtype.CMCChange,
    EventSubtype.SafetyUpdates,
    EventSubtype.Administrative,
    EventSubtype.Other,
  ],
  [EventType.Safety]: [
    EventSubtype.Pharmacovigilance,
    EventSubtype.Pharmacology,
    EventSubtype.Pharmacokinetics,
    EventSubtype.Toxicology,
    EventSubtype.Other,
  ],
  [EventType.Other]: [],
};

export type TEventTypes = typeof EventTypes;

export const DEPRECATED_PARAM = "showDeprecated";
